import { get, patch } from "@/services/axiosUitils";

class RosterService {
  /**
   * Check member by email
   */
  checkMemberByEmail = async (email: string): Promise<any> => {
    if (!email) {
      throw new Error("Email is required");
    }
    return await get("/city_collab/roster-import/check-member-by-email/", {
      params: {
        email,
      },
    });
  };

  /**
   * Get member status counts (pending, approved, rejected)
   */
  getMemberStatusCounts = async (): Promise<{
    pending: number;
    approved: number;
    rejected: number;
  }> => {
    const response = await get<any>(
      "/city_collab/roster-import/member-status-counts/",
      {
        notifyMessage: false,
      }
    );

    // Handle different response structures
    if (response?.data) {
      return {
        pending: Number(response.data.pending) || 0,
        approved: Number(response.data.approved) || 0,
        rejected: Number(response.data.rejected) || 0,
      };
    }

    return {
      pending: Number(response?.pending) || 0,
      approved: Number(response?.approved) || 0,
      rejected: Number(response?.rejected) || 0,
    };
  };

  /**
   * Update member status (approve/reject member inquiry)
   */
  updateMemberStatus = async (
    memberId: string,
    status: string = "Approved",
    reason?: string
  ): Promise<any> => {
    if (!memberId) {
      throw new Error("Member ID is required");
    }
    const data: any = {
      member_id: memberId,
      status: status,
    };
    if (reason) {
      data.reason = reason;
    }
    return await patch(
      "/city_collab/roster-import/update-member-status/",
      data,
      {
        notifyMessage: true,
      }
    );
  };
}

export default new RosterService();
